import { findMany, on, fire } from '../helpers';

findMany('[data-submit-on-change]').forEach(element => {
    on('change', () => {
        fire('submit', element.form)
    }, element)
});
